import { render, staticRenderFns } from "./marketingReportTabs.vue?vue&type=template&id=b04714ee&scoped=true"
import script from "./marketingReportTabs.vue?vue&type=script&lang=js"
export * from "./marketingReportTabs.vue?vue&type=script&lang=js"
import style0 from "./marketingReportTabs.vue?vue&type=style&index=0&id=b04714ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04714ee",
  null
  
)

export default component.exports